import React from "react"
import { Radio, Checkbox, Slider, Button, Typography } from "antd"
import { categories, allProducts, productType } from "../data/productsData"
const { Title } = Typography

const FilterProduct = ({ filters, setFilters, hideCategoryFilter }) => {
  const handleSortChange = e => {
    setFilters(prev => ({ ...prev, sortBy: e.target.value }))
  }

  const handleCategoryChange = checkedValues => {
    setFilters(prev => ({ ...prev, categories: checkedValues }))
  }

  const handlePriceChange = value => {
    setFilters(prev => ({ ...prev, priceRange: value }))
  }

  const resetFilters = () => {
    setFilters({
      sortBy: "",
      categories: [],
      priceRange: [0, 1000000000],
      productTypeId: null,
    })
  }

  const handleProductTypeClick = productTypeId => {
    setFilters(prev => ({
      ...prev,
      productTypeId:
        prev.productTypeId === productTypeId ? null : productTypeId,
      categories: [],
    }))
  }

  // Tính số lượng sản phẩm theo từng category
  const categoryOptions = categories
    .map(cat => {
      // Lọc sản phẩm theo categoryId và productTypeId (nếu có)
      const productCount = allProducts.filter(
        product =>
          product.categoryId === cat.id &&
          (!filters.productTypeId ||
            product.productTypeId === filters.productTypeId),
      ).length

      const displayCount =
        productCount >= 1000
          ? `${Math.floor(productCount / 1000)}k+`
          : productCount.toString()

      return {
        label: `${cat.title} (${displayCount})`,
        value: cat.id,
        disabled: productCount === 0,
      }
    })
    .filter(option => !filters.productTypeId || !option.disabled)

  return (
    <div
      style={{
        padding: "16px",
        background: "#fff",
        borderRadius: "8px",
        maxWidth: "280px",
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
      }}
    >
      {/* Tất cả danh mục */}
      <div
        style={{ display: "flex", alignItems: "center", marginBottom: "16px" }}
      >
        <svg
          style={{ width: "20px", height: "20px", marginRight: "8px" }}
          fill="none"
          stroke="#154398"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M4 6h16M4 12h16M4 18h16"
          />
        </svg>
        <Title
          level={5}
          style={{
            color: "#154398",
            fontWeight: "bold",
            margin: 0,
            cursor: "pointer",
          }}
          onClick={resetFilters}
        >
          Tất Cả Danh Mục
        </Title>
      </div>
      <div style={{ marginBottom: "16px" }}>
        {productType.map(type => {
          // Đếm số sản phẩm thuộc loại này
          const productCount = allProducts.filter(
            p => p.productTypeId === type.id,
          ).length

          return (
            <div
              key={type.id}
              onClick={() => handleProductTypeClick(type.id)}
              style={{
                padding: "8px 0",
                cursor: "pointer",
                color: filters.productTypeId === type.id ? "#ed1117" : "#000",
                fontWeight:
                  filters.productTypeId === type.id ? "600" : "normal",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <span>{type.name}</span>
              <span
                style={{
                  backgroundColor: "#f0f0f0",
                  padding: "2px 8px",
                  borderRadius: "10px",
                  fontSize: "12px",
                }}
              >
                {productCount}
              </span>
            </div>
          )
        })}
      </div>

      {/* Bộ lọc tìm kiếm */}
      <div
        style={{ display: "flex", alignItems: "center", marginBottom: "16px" }}
      >
        <svg
          style={{ width: "20px", height: "20px", marginRight: "8px" }}
          fill="none"
          stroke="#154398"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
          />
        </svg>
        <Title
          level={5}
          style={{ color: "#154398", fontWeight: "bold", margin: 0 }}
        >
          BỘ LỌC TÌM KIẾM
        </Title>
      </div>

      {/* Sắp xếp */}
      <h4 style={{ fontWeight: 600, color: "#154398", marginBottom: "8px" }}>
        Sắp xếp
      </h4>
      <Radio.Group
        onChange={handleSortChange}
        value={filters.sortBy}
        style={{ display: "flex", flexDirection: "column", gap: "8px" }}
      >
        <Radio value="">Tất cả</Radio>
        <Radio value="best-seller">Bán chạy nhất</Radio>
        <Radio value="newest">Mới nhất</Radio>
        <Radio value="price-low-high">Giá (Thấp - Cao)</Radio>
        <Radio value="price-high-low">Giá (Cao - Thấp)</Radio>
      </Radio.Group>

      {/* Theo danh mục */}
      {!hideCategoryFilter &&
        (filters.productTypeId ||
          categoryOptions.some(opt => !opt.disabled)) && (
          <div style={{ marginTop: "16px" }}>
            <h4
              style={{ fontWeight: 600, color: "#154398", marginBottom: "8px" }}
            >
              Theo Danh Mục
            </h4>
            <Checkbox.Group
              options={categoryOptions}
              onChange={handleCategoryChange}
              value={filters.categories}
              style={{ display: "flex", flexDirection: "column", gap: "8px" }}
            />
          </div>
        )}
      {/* Khoảng giá */}
      <h4
        style={{
          fontWeight: 600,
          color: "#154398",
          marginTop: "16px",
          marginBottom: "8px",
        }}
      >
        Khoảng giá
      </h4>
      <div
        style={{ textAlign: "center", fontWeight: "bold", marginBottom: "8px" }}
      >
        {`${filters.priceRange[0].toLocaleString(
          "vi-VN",
        )}đ - ${filters.priceRange[1].toLocaleString("vi-VN")}đ`}
      </div>
      <Slider
        range
        min={0}
        max={1000000000}
        step={1000000}
        value={filters.priceRange}
        onChange={handlePriceChange}
        tooltip={{ open: false }}
      />

      {/* Nút đặt lại bộ lọc */}
      <Button
        style={{
          background: "linear-gradient(90deg, #154398 0%, #e4353a 100%)",
          borderColor: "rgb(5, 30, 255)",
          borderRadius: "8px",
          color: "white",
          marginTop: "16px",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
        }}
        onClick={resetFilters}
        block
      >
        Đặt lại bộ lọc
      </Button>
    </div>
  )
}

export default FilterProduct
